export const DEFAULT_REPOSITORY_OWNER = 'socialpoint-games';
export const LEGACY_REPOSITORY_OWNER = 'socialpoint';

export interface ProjectRemoteConfig {
  studio: string;
  disabled: boolean;
  facebookAppSecret: string;
  madId: number;
  launchpad: boolean;
  dynApiEndpoint: string;
  proxyEndpoint: string;
  facebookAppId: string;
  dynenvChart: string;
  dynenvBranch: string;
  googleLinkEnabled: boolean;
  backendRepository: string;
  configsRepository: string;
  backendRepositoryOwner: string;
  configsRepositoryOwner: string;
  deployTargetCommitish: string;
}

export function parseProjectRemoteConfig(
  remoteJson: string,
): ProjectRemoteConfig {
  let studio = null;
  let disabled = false;
  let facebookAppSecret = '';
  let madId = null;
  let launchpad = null;
  let dynApiEndpoint = null;
  let proxyEndpoint = null;
  let facebookAppId = null;
  let dynenvChart = null;
  let dynenvBranch = null;
  let googleLinkEnabled = false;
  let backendRepository = null;
  let configsRepository = null;
  let backendRepositoryOwner = DEFAULT_REPOSITORY_OWNER;
  let configsRepositoryOwner = DEFAULT_REPOSITORY_OWNER;
  let deployTargetCommitish = null;
  try {
    const dataObj = JSON.parse(remoteJson);
    if ('studio' in dataObj) studio = dataObj.studio;
    if ('disabled' in dataObj) disabled = dataObj.disabled;
    if ('facebookAppSecret' in dataObj)
      facebookAppSecret = dataObj.facebookAppSecret;
    if ('mad_id' in dataObj) madId = dataObj.mad_id;
    if ('launchpad' in dataObj) launchpad = dataObj.launchpad;
    if ('dynapi_endpoint' in dataObj) dynApiEndpoint = dataObj.dynapi_endpoint;
    if ('proxy_endpoint' in dataObj) proxyEndpoint = dataObj.proxy_endpoint;
    if ('facebook_app_id' in dataObj)
      facebookAppId = String(dataObj.facebook_app_id);
    if ('dynenv_chart' in dataObj) dynenvChart = dataObj.dynenv_chart;
    if ('dynenv_branch' in dataObj) dynenvBranch = dataObj.dynenv_branch;
    if ('google_link_enabled' in dataObj)
      googleLinkEnabled = dataObj.google_link_enabled;
    if ('backend_repository' in dataObj)
      backendRepository = dataObj.backend_repository;
    if ('configs_repository' in dataObj)
      configsRepository = dataObj.configs_repository;
    if (
      typeof dataObj.backend_repository_owner === 'string' &&
      dataObj.backend_repository_owner.trim() !== ''
    )
      backendRepositoryOwner = dataObj.backend_repository_owner.trim();
    if (
      typeof dataObj.configs_repository_owner === 'string' &&
      dataObj.configs_repository_owner.trim() !== ''
    )
      configsRepositoryOwner = dataObj.configs_repository_owner.trim();
    if ('deploy_target_commitish' in dataObj)
      deployTargetCommitish = dataObj.deploy_target_commitish;
  } catch {}

  return {
    studio,
    disabled,
    facebookAppSecret,
    madId,
    launchpad,
    dynApiEndpoint,
    proxyEndpoint,
    facebookAppId,
    dynenvChart,
    dynenvBranch,
    googleLinkEnabled,
    backendRepository,
    configsRepository,
    backendRepositoryOwner,
    configsRepositoryOwner,
    deployTargetCommitish,
  };
}
